import React from "react";
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  customTooltip: {
    backgroundColor: '#EBE9FF',
    color: '#4F4E70',
    fontSize: '12px',
    padding: '10px 12px',
    maxWidth: 280,
    borderRadius: 8,
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
  },
  arrow: {
    color: '#EBE9FF',
  },
}));
const StaticIpModal = ({
  staticIpModal,
  closeModal,
  appData,
  onSubmit,
  onChange,
  error,
}) => {
    const classes = useStyles();
  return (
    <div id={staticIpModal.isOpen ? "show_modal" : "hide_modal"}>
      <div className="modal_MyApp">
        <div className="modal_StaticIp createIP">
          <h2 className="head">Add Static IP Address</h2>
          <p className="field-subHead">App name: {appData.appNm}</p>

          <div className="custom-col-12 align-center mb-30">
            <div className="custom-col-4">
              <label htmlFor="staticIP_Primary" style={{marginRight:'8px'}}>Static IP Primary*</label>
              <Tooltip
                title={
                  <>
                    <p>
                      To comply with SEBI’s latest circular on algorithmic
                      trading, all users accessing APIs must register a static
                      IP address. Mandatory before April 1st, 2026.
                    </p>
                    <br />
                    <br />
                    <p>
                      Contact your Internet Service Provider and request a
                       Static IP.
                    </p>
                  </>
                }
                arrow
                placement="bottom"
                classes={{
                  tooltip: classes.customTooltip,
                  arrow: classes.arrow,
                }}
              >
                <i className="edel-icon-tooltip" style={{color:'#6374D4', fontSize: '20px'}}></i>
              </Tooltip>
            </div>
            <div className="custom-col-8">
              <input
                id="staticIP_Primary"
                type="text"
                name="primaryIp"
                value={appData.primaryIp}
                onChange={onChange}
              />
              <span className="static_Ip_note">
                Please Note: The IP address can only be changed once in a
                calendar week.
              </span>
              {error.primaryIp && (
                <span className="form-err">{error.primaryIp}</span>
              )}
            </div>
          </div>
          <div className="custom-col-12 align-center mb-30">
            <div className="custom-col-4 tooltip">
              <label htmlFor="staticIP_Secondary" style={{marginRight:'8px'}}>Static IP Secondary</label>
              <Tooltip
                title={
                  <>
                    <p>
                      A backup or additional IP address that can handle requests
                      if the primary fails or is overloaded.
                    </p>
                  </>
                }
                arrow
                placement="bottom"
                classes={{
                  tooltip: classes.customTooltip,
                  arrow: classes.arrow,
                }}
              >
                <i className="edel-icon-tooltip" style={{color:'#6374D4', fontSize: '20px'}}></i>
              </Tooltip>
            </div>
            <div className="custom-col-8">
              <input
                id="staticIP_Secondary"
                type="text"
                name="secondaryIp"
                value={appData.secondaryIp}
                onChange={onChange}
              />
              {error.secondaryIp && (
                <span className="form-err">{error.secondaryIp}</span>
              )}
            </div>
          </div>

          <div className="display-flex w-100 desktopAppFormBtn gap-20">
            <button className="custom-btn border-btn w-30 mr-20" onClick={closeModal}>
              Cancel
            </button>
            <button className="custom-btn block-btn w-70" onClick={onSubmit}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaticIpModal;
